import { styled } from "styled-components";
import { device } from "../../styles/style";

export const Box = styled.div`
  background-color: var(--mainBgColor);
  border: solid 1px var(--grey);
  color: var(--secondaryTextColor);
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  font-size: 0.5rem;
  text-align: center;
  cursor: pointer;

  h1 {
    width: 120px;
    font-size: 0.7rem;
  }

  img {
    width: 100px;
  }

  &:hover {
    box-shadow: 0 0 5px #fff;
  }

  @media ${device.mobileS} and ${device.tablet} {
    width: 50px;
    height: 50px;

    h1 {
      font-size: 0.4rem;
      width: 40px;
    }

    img {
      width: 30px;
    }
  }

  @media ${device.laptop} and ${device.laptopMax} {
    width: 100px;
    height: 100px;

    h1 {
      font-size: 0.7rem;
      width: 90px;
    }

    img {
      width: 70px;
    }
  }

  @media (min-width: 1025px) {
    width: 120px;
    height: 120px;
  }

  @media${device.tv} {
    width: 170px;
    height: 170px;
    font-size: 0.8rem;

    h1 {
      font-size: 1rem;
      width: 150px;
    }

    img {
      width: 110px;
    }
  }

  @media${device.tvL} {
    width: 190px;
    height: 190px;
    font-size: 1rem;

    h1 {
      font-size: 1.2rem;
      width: 170px;
    }

    img {
      width: 140px;
    }
  }

  @media${device.uhd} {
    width: 300px;
    height: 300px;
    font-size: 2rem;

    h1 {
      font-size: 2.3rem;
      width: 290px;
    }

    img {
      width: 230px;
    }
  }
`;
